import api from '../token';

export const DeleteCliente = async (dados) => {
  try {
    const response = await api.post('/deleteCliente', dados);
    return response.data;
  } catch (error) {
     
    return { success: false, message: error.message };
  }
};


